import styled from "styled-components";

export const PageLayout = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;

export const SurfaceCard = styled.section`
  position: relative;
  z-index: ${({$open}) => $open ? 20 : 1};
  overflow: ${({$open}) => $open ? "visible" : "hidden"};
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(31, 41, 55, .045);
`;

export const ConditionBody = styled.div`
  padding: 18px 20px 16px;
  border-top: ${({$bordered}) => $bordered ? "1px solid #edf0f3" : 0};
`;

export const FieldLabel = styled.label`
  color: #444;
  font-size: 11px;
  font-weight: 700;
`;

export const ConditionFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #edf0f3;
  color: #929ba5;
  font-size: 9px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const SecondaryButton = styled.button`
  min-width: 86px;
  height: 40px;
  padding: 0 16px;
  border: 1px solid #dfe3e7;
  border-radius: 7px;
  background: #fff;
  color: #68717c;
  font-size: 11px;
  font-weight: 650;
  cursor: pointer;
`;

export const PrimaryButton = styled(SecondaryButton)`
  border-color: var(--theme-primary-strong);
  background: var(--theme-primary-strong);
  color: #fff;

  &:hover {
    background: var(--theme-primary-hover);
  }
`;

export const HeaderAddAction = styled.div`
  button {
    min-width: 104px;
    height: 40px;
    padding: 0 16px;
    border: 1px solid var(--theme-primary-border) !important;
    border-radius: 7px !important;
    background: var(--theme-primary-soft) !important;
    color: var(--theme-primary-strong) !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    box-shadow: none !important;
  }

  button:hover {
    background: var(--theme-primary-soft-hover) !important;
  }
`;

export const StatusTag = styled.span`
  display: inline-flex;
  min-width: 52px;
  height: 24px;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border: 1px solid ${({$active}) => $active ? "#b7e4cd" : "#f3b7b7"};
  border-radius: 999px;
  background: ${({$active}) => $active ? "#edf9f3" : "#fff1f1"};
  color: ${({$active}) => $active ? "#168253" : "#d04444"};
  font-size: 10px;
  font-weight: 700;
`;

export const DetailForm = styled.form`
  width: 100%;
`;

export const DetailBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
`;

export const DetailFieldGroup = styled.section`
  padding: 18px;
  border: 1px solid #e5eaf0;
  border-radius: 9px;
  background: #fafbfc;
`;

export const DetailFieldLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-size: 12px;
  font-weight: 700;
`;

export const FieldDescription = styled.p`
  margin: 0 0 12px;
  color: #8a9299;
  font-size: 9px;
  line-height: 1.5;
`;

export const RequiredMark = styled.span`
  color: var(--theme-primary);
`;

export const StickyActionBar = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 18px;
  padding: 16px 20px;
  border: 1px solid var(--theme-primary-border);
  border-left: 4px solid var(--theme-primary);
  border-radius: 10px;
  background: var(--theme-primary-softest);
  box-shadow: 0 -4px 20px var(--theme-primary-opacity-08);

  @media (max-width: 640px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const ActionGuide = styled.div`
  strong,
  span {
    display: block;
  }

  strong {
    color: #2f3438;
    font-size: 12px;
    font-weight: 800;
  }

  span {
    margin-top: 4px;
    color: #7f878e;
    font-size: 9px;
  }
`;
